import { useEffect, useState } from "react";
import { CalendarX } from "@phosphor-icons/react";
import { SettingsCrud } from "./SettingsCrud";
import api from "../../lib/api";

export function HolidaysSettings() {
  const [branches, setBranches] = useState([]);
  useEffect(() => {
    api.get("/branches").then(({ data }) =>
      setBranches((data || []).filter((b) => b.active !== false).map((b) => ({ value: b.id, label: b.name })))).catch(() => {});
  }, []);

  return (
    <SettingsCrud
      testid="holidays"
      title="Holidays"
      icon={CalendarX}
      description="Company and branch holidays. Stored as configuration only — not yet applied to calendars or attendance."
      endpoint="/holidays"
      subtitle={(h) => [h.date, h.branch_name || "All branches", h.recurring && "Recurring"].filter(Boolean).join(" · ")}
      fields={[
        { name: "name", label: "Holiday name", type: "text", required: true, placeholder: "e.g. New Year's Day" },
        { name: "date", label: "Date", type: "date", required: true },
        { name: "branch_id", label: "Branch", type: "select", options: branches, allowEmpty: true, emptyLabel: "All branches" },
        { name: "recurring", label: "Repeats annually", type: "boolean", switchLabel: "Recurring every year" },
      ]}
    />
  );
}

export default HolidaysSettings;
